/* eslint-disable max-classes-per-file */
import { observable } from 'mobx';
import { copyPropertiesExcludeNullsAndGetters } from '../../utils/ObjectUtils';

export interface IKeyName {
    key: string;
    name: string;
}

export class KeyNameEntity implements IKeyName {
    @observable public key: string = '';
    @observable public name: string = '';

    public static fromJson(data: IKeyName): KeyNameEntity {
        const newKeyName = new KeyNameEntity();
        if (!data) {
            return newKeyName;
        }
        copyPropertiesExcludeNullsAndGetters(newKeyName, data);

        return newKeyName;
    }
}

export interface IValue {
    key?: string;
    value: string;
}

export class ValueEntity implements IValue {
    @observable public key?: string;
    @observable public value: string = '';

    public static fromJson(data: IValue): ValueEntity {
        const newValue = new ValueEntity();
        if (!data) {
            return newValue;
        }
        copyPropertiesExcludeNullsAndGetters(newValue, data);

        return newValue;
    }
}

export interface IKeyValue {
    key: string;
    value: string;
}

export class KeyValueEntity extends ValueEntity implements IKeyValue {
    @observable public key: string = '';

    public static fromJson(data: IKeyValue): KeyValueEntity {
        const newKeyValue = new KeyValueEntity();
        if (!data) {
            return newKeyValue;
        }
        copyPropertiesExcludeNullsAndGetters(newKeyValue, data);

        return newKeyValue;
    }
}
